import React from 'react'
import { Accordion, Space, TextHeading } from '@ally/metronome-ui'
import { eddFaqsContent } from './EddFaqsContent'

export const EddFaqsModalContent: React.FC = () => {
  return (
    <Space mb="xs">
      <TextHeading tag="h2" size="xs" data-testid="edd-faqs-title">
        Early direct deposit FAQs
      </TextHeading>

      <Accordion items={eddFaqsContent} disableContainer />
    </Space>
  )
}
